var exports = {
  "T": "x43aef4ae--75509a--map",
};

module.exports = exports;
